import { Button, FlexRow } from '@epam/loveship'
import {
  CategoryResponse,
  EventResponse,
  ExtendedEvent,
} from '../../../../../../constants/types'
import { EventCard } from '../EventCard/EventCard'
import { getExtendedEvent } from '../../../../../../utils/common/getExtendedEvent'
import { useAppSelector } from '../../../../../../hooks/redux/redux'
import { useSideBarControlls } from '../../../../../../hooks/useSideBarControlls'
import { useEffect, useRef } from 'react'
import css from './EventList.module.scss'

interface EventListProps {
  events: ExtendedEvent[]
  categories: CategoryResponse[] | undefined
}

export const EventList: React.FC<EventListProps> = ({ events, categories }) => {
  const { showCreateNewEvent, resetEventScroll } = useSideBarControlls()
  const { scrollTargetEventId } = useAppSelector((state) => state.events)
  const scrollTargetEventRef = useRef(null)

  useEffect(() => {
    if (scrollTargetEventRef.current) {
      ;(scrollTargetEventRef.current as any).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'center',
      })
      resetEventScroll()
    }
  })

  return (
    <>
      <FlexRow padding="24">
        <Button
          cx={css.toggleBtn}
          fill="white"
          color="sky"
          caption="+ Create event"
          onClick={showCreateNewEvent}
        />
      </FlexRow>
      {events.map((event: EventResponse) => (
        <div
          key={event.id}
          ref={event.id === scrollTargetEventId ? scrollTargetEventRef : null}
        >
          <EventCard extendedEvent={getExtendedEvent(event, categories)} />
        </div>
      ))}
    </>
  )
}
